import React from 'react';

const Facebook = () => {
    const currentUrl = window.location.href;
    const facebookShareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(currentUrl)}`;

    return (
        <a
            className="player-app__share-link episode-player-facebook"
            href={facebookShareUrl}
            target="_blank"
            rel="noreferrer"
        >
            <svg width="10" height="16" viewBox="0 0 10 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M8.65832 8.93204L9.09476 6.05825H6.36465V4.19417C6.36465 3.40777 6.74532 2.64078 7.96811 2.64078H9.21012V0.194175C9.21012 0.194175 8.08346 0 7.0068 0C4.75734 0 3.28846 1.3767 3.28846 3.86796V6.05825H0.789062V8.93204H3.28846V15.8796C3.79026 15.9592 4.3036 16 4.82655 16C5.3495 16 5.86284 15.9592 6.36465 15.8796V8.93204H8.65832Z" fill="white"/>
            </svg>
            <span>Share</span>
        </a>
    );
};

export default Facebook;
